import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import LiveParts from 'components/molecules/LiveParts';

import './index.scss';

// Phones are stored country-code normalized (e.g. "201552500799"); show them as "+20 1552500799".
const formatPhone = (phoneNumber) => {
  if (!phoneNumber) return '';
  const digits = String(phoneNumber).replace(/\D/g, '');
  return digits.startsWith('20') ? `+20 ${digits.slice(2)}` : `+${digits}`;
};

const UserInfo = ({ name, phoneNumber, balance }) => {
  const { t } = useTranslation('user-info');

  return (
    <div className="user-info-wrapper">
      <div className="sub-info-wrapper">
        <span className="info-label">{t('user-name')}</span>
        <span className="info-value">{name}</span>
      </div>
      <div className="sub-info-wrapper">
        <span className="info-label">{t('user-phone')}</span>
        <span className="info-value" dir="ltr">
          {formatPhone(phoneNumber)}
        </span>
      </div>
      <div className="sub-info-wrapper">
        <span className="info-label">{t('user-balance')}</span>
        <span className="info-value" dir="ltr">
          {balance != null && `${balance.toLocaleString()} ${t('currency')}`}
        </span>
      </div>
      <LiveParts />
    </div>
  );
};

UserInfo.PropType = {
  name: PropTypes.string,
  phoneNumber: PropTypes.number,
  balance: PropTypes.number,
};
export default UserInfo;
